import { Typography } from '@mui/material';

type UserForeignSystemListTitleProps = {
    title: string,
    customStyles?: { [key:string]: unknown }
}

const DEFAULT_INLINE_STYLES = {
    color: 'info.light',
};

export function UserForeignSystemListTitle({
    title,
    customStyles = DEFAULT_INLINE_STYLES
}: Readonly<UserForeignSystemListTitleProps>) {
    const INLINE_STYLES = {
        ...DEFAULT_INLINE_STYLES,
        customStyles
    };
    return(
        <Typography
            align="left"
            component="div"
            sx={INLINE_STYLES}
        >{title}
        </Typography>
    );
}
